module.exports = __webpack_public_path__ + "static/media/accident-default-image3.37b83c07.png";